// import { assert } from '@/core';
import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './utils';

// This is a interface which extendds
export class TopoGroupService extends BaseService {
  static get entity() {
    return 'groups';
  }

  static async getAllGroups() {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}`);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getAppsByGroup(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/${id}/apps`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async createGroup(data) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity}`,
        data
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async updateGroup(id, data) {
    try {
      const response = await this.request({ auth: true }).put(
        `${this.entity}/${id}`,
        data
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async deleteGroup(id) {
    try {
      const response = await this.request({ auth: true }).delete(
        `${this.entity}/${id}`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
